
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TestimonialSection = () => (
    <Box sx={{ bgcolor: 'custom.beige', py: { xs: 4, md: 6 }, px: { xs: 1, md: 0 } }}>
        <Paper elevation={2} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white', maxWidth: 900, mx: 'auto' }}>
            <Typography variant="h2" color="text.secondary" align="center" gutterBottom>
                Testimonial
            </Typography>
            <Typography variant="subtitle1" color="text.primary" align="center" sx={{ mb: 3 }}>
                We value your feedback! Here’s what one of our customers had to say about their experience.
            </Typography>
            <Box display="flex" justifyContent="center">
                <Box
                    component="img"
                    src="/assets/testimonial.jpeg"
                    alt="Testimonial"
                    sx={{
                        width: { xs: '100%', sm: 400, md: 500 },
                        maxWidth: '100%',
                        borderRadius: 2,
                        boxShadow: 3,
                        mb: 2
                    }}
                />
            </Box>
        </Paper>
    </Box>
);

export default TestimonialSection;
